// assets
import {
    IconKey,
    IconBallTennis,
    IconUsers,
    IconDashboard,
    IconCashBanknote,
    IconFileSpreadsheet,
    IconDevices,
    IconGiftCard,
    IconDiscount,
    IconApps,
    IconAppWindow,
    IconUser
} from '@tabler/icons';
import { getUrlCourtCode } from 'helper/Court';

// constant
const icons = {
    IconKey,
    IconBallTennis,
    IconUsers,
    IconDashboard,
    IconCashBanknote,
    IconFileSpreadsheet,
    IconDevices,
    IconGiftCard,
    IconDiscount,
    IconApps,
    IconAppWindow,
    IconUser
};

const merchantsRaw = {
    id: 'merchants',
    title: '',
    caption: '',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: `/${getUrlCourtCode()}/dashboard`,
            icon: icons.IconDashboard,
            breadcrumbs: true,
            meta: { permission: 'dashboard' },
        },
        {
            id: 'orders',
            title: 'Order',
            type: 'item',
            url: `/${getUrlCourtCode()}/orders`,
            icon: icons.IconBallTennis,
            meta: { permission: 'order' },
        },
        {
            id: 'payments',
            title: 'Payment',
            type: 'item',
            url: `/${getUrlCourtCode()}/payments`,
            icon: icons.IconCashBanknote,
            meta: { permission: 'payment' },
        },
        // Marketing group is shown if ANY marketing child is allowed (parent has no permission)
        {
            id: 'marketing',
            title: 'Marketing',
            type: 'collapse',
            icon: icons.IconDevices,
            children: [
                {
                    id: 'packages',
                    title: 'Value Pack',
                    type: 'item',
                    url: `/${getUrlCourtCode()}/packages`,
                    icon: icons.IconAppWindow,
                    meta: { permission: 'value_pack' },
                    children: [
                        { id: 'packageadd', title: 'Add', type: 'item', url: '/add' },
                        { id: 'packageedit', title: 'Edit', type: 'item', url: '/edit' },
                    ],
                },
                {
                    id: 'coupons',
                    title: 'Promo Code',
                    type: 'item',
                    url: `/${getUrlCourtCode()}/coupons`,
                    icon: icons.IconDiscount,
                    meta: { permission: 'promo_code' },
                    children: [
                        { id: 'couponadd', title: 'Add', type: 'item', url: '/add' },
                        { id: 'couponedit', title: 'Edit', type: 'item', url: '/edit' },
                    ],
                },
                {
                    id: 'vouchers',
                    title: 'Voucher',
                    type: 'item',
                    url: `/${getUrlCourtCode()}/vouchers`,
                    icon: icons.IconGiftCard,
                    meta: { permission: 'voucher' },
                    children: [
                        { id: 'voucheradd', title: 'Add', type: 'item', url: '/add' },
                        { id: 'voucheredit', title: 'Edit', type: 'item', url: '/edit' },
                    ],
                },
            ],
        },
        {
            id: 'addon',
            title: 'Add-On',
            type: 'item',
            url: `/${getUrlCourtCode()}/addon`,
            icon: icons.IconApps,
            meta: { permission: 'add_on' },
            children: [
                { id: 'addonadd', title: 'Add', type: 'item', url: '/add' },
                { id: 'addonedit', title: 'Edit', type: 'item', url: '/edit' },
            ],
        },
        {
            id: 'classes',
            title: 'Class & Event',
            type: 'item',
            url: `/${getUrlCourtCode()}/classes`,
            icon: icons.IconBallTennis,
            meta: { permission: 'classes' },
            children: [
                { id: 'createclass', title: 'Create', type: 'item', url: '/add' },
                { id: 'detailorder', title: 'Edit', type: 'item', url: '/edit' },
            ],
        },
    ],
};

// // Filtered export (this is what sidebar uses)
// const merchants = {
//     ...merchantsRaw,
//     // children: filterMenuByPermission(merchantsRaw.children),
// };

export default merchantsRaw;
